import { Component, OnInit } from '@angular/core';

import { getCookie, setCookie } from '../utils/geral';
import { GruposService } from '../service/grupos.service';
import { EventEmitterService } from '../service/event-emitter.service';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
})
export class PortalComponent implements OnInit {
  menuAberto: any;
  isPrimeiroAcesso: boolean = false;
  visao: string = '';
  iconeLogo = '';

  constructor(private permissaoService: GruposService) { }

  ngOnInit(): void {
    this.getCustomizacoes();

    EventEmitterService.get('abreMenu').subscribe((data) => {
      this.menuAberto = data;
    });
  }

  obterVisao(visao: string) {
    if (visao) {
      this.visao = visao;
    }
  }

  changeMenu(event: any) {
    this.menuAberto = event;
  }

  getCustomizacoes(): void {
    this.waitForTenantCookie(5000).then(async (tenant_id) => {
      if (tenant_id) {
        let customizacoes: any = await this.permissaoService.getCustomizacoes(getCookie('tenant_id'));
        if (customizacoes && customizacoes.length) {
          let customizacao = customizacoes[0];
          if (customizacao && customizacao.logoUrl) {
            this.iconeLogo = customizacao.logoUrl;
            return;
          }
        }
      } else {
        this.iconeLogo = 'assets/images/logos/wba-logo.svg';
      }
    });
  }

  waitForTenantCookie(timeoutMs: number): Promise<string | null> {
    const intervalMs = 1000;
    const maxTries = Math.ceil(timeoutMs / intervalMs);
    let tries = 0;

    return new Promise((resolve) => {
      const interval = setInterval(() => {
        const tenantId = getCookie('tenant_id');
        if (tenantId) {
          clearInterval(interval);
          resolve(tenantId);
        } else if (++tries >= maxTries) {
          clearInterval(interval);
          resolve(null);
        }
      }, intervalMs);
    });
  }
}
